import { useEffect, useRef, useState, useContext } from "react";
import PropTypes from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";
import Button from "../../components/button";

const LoanDetailsContainer = ({ classOption = "section-pb" }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);
    const [videoSrc, setVideoSrc] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility

    const openModal = (param) => (e) => {
        setIsModalOpen(true);
        setVideoSrc(param);
    };
    const closeModal = () => setIsModalOpen(false);

    useEffect(() => {
        if (isModalOpen) {
            // setVideoSrc(
            //     "https://www.youtube.com/embed/oUZnCGZpLyU?si=hjVgsQtFHyANoGb6&autoplay=1"
            // );
        } else {
            setVideoSrc(""); // Stop video when modal is closed
        }
    }, [isModalOpen]);

    const sceneEl = useRef(null);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);

        // const parallaxInstance = new Parallax(sceneEl.current, {
        //     relativeInput: true,
        // });

        // parallaxInstance.enable();

        // return () => parallaxInstance.disable();
    }, []);

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    return (
        <div className={`testimonial-section position-relative ${classOption}`}>
            <div className="m-10">
                <div className="row justify-content-around">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-12 mb-5">
                        <div className=" g-background-color g-border radius-box p-3 hover-scale-div">
                            <div className="row mb-1 item-desk">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "images/products/small.png"
                                    }
                                    alt="NeoGrowth "
                                    width={"40%"}
                                    className="radius-box "
                                />
                            </div>
                            <div className="d-flex justify-content-evenly">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "images/products/small.png"
                                    }
                                    alt="NeoGrowth "
                                    width={"24%"}
                                    className="radius-box item-mobile p-1"
                                    style={{
                                        border: "solid 3px rgb(58, 181, 75)",
                                    }}
                                />
                                <div className="align-self-center text-center ms-4">
                                    <h4 className="title text-center g-color">
                                        <b>Instant Business Loan</b>
                                    </h4>

                                    <p className="b-color">
                                        <b>From ₹ 5 Lakhs to ₹ 30 Lakhs</b>
                                    </p>

                                    <p>
                                        Only for Retailers of Goods & Services
                                    </p>
                                    {/* <Button
                                        classOption="btn btn-sm btn-primary btn-hover-primary"
                                        text="Apply Now"
                                        link={"https://instaas2.neogrowth.in/"}
                                    ></Button> */}
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div
                                    className="col-xl-12 col-lg-12 col-12 mb-4 text-center
                                "
                                >
                                    <Button
                                        classOption="btn btn-sm btn-primary btn-hover-primary"
                                        text="Apply Now"
                                        link={"https://instaas2.neogrowth.in/"}
                                    ></Button>

                                    <hr></hr>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-12 mb-4">
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Collateral-free Business Loans
                                    </p>
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Online loan application
                                    </p>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-12 mb-4">
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Minimum documentation
                                    </p>
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Superfast disbursals
                                    </p>
                                </div>
                                <div className="col-xl-12 col-lg-12 col-12 mb-5">
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Daily repayment starts as ₹188 / Lakh
                                        only
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-12 mb-5">
                        <div className=" y-background-color  radius-box p-3 y-border hover-scale-div">
                            <div className="row mb-1 item-desk">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "images/products/large.png"
                                    }
                                    alt="NeoGrowth "
                                    width={"30%"}
                                    className="radius-box mb-4"
                                />
                            </div>
                            <div className="d-flex justify-content-evenly">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "images/products/large.png"
                                    }
                                    alt="NeoGrowth "
                                    width={"24%"}
                                    className="radius-box item-mobile p-1"
                                    style={{
                                        border: "solid 3px rgb(58, 181, 75)",
                                    }}
                                />
                                <div className="align-self-center text-center ms-4">
                                    <h4 className="title text-center g-color">
                                        <b>Large Business Loan</b>
                                    </h4>

                                    <p className="b-color">
                                        <b>Up to ₹ 75 Lakhs</b>
                                    </p>
                                    <p>
                                        For Retailers, Manufacturers,
                                        <br />
                                        Distributors & Service Providers
                                    </p>
                                    {/* <Button
                                        classOption="btn btn-sm btn-primary btn-hover-primary"
                                        text="Apply Now"
                                        link={"register-form"}
                                    ></Button> */}
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div
                                    className="col-xl-12 col-lg-12 col-12 mb-4 text-center
                                "
                                >
                                    <Button
                                        classOption="btn btn-sm btn-primary btn-hover-primary"
                                        text="Apply Now"
                                        path={"register-form"}
                                    ></Button>

                                    <hr></hr>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-12 mb-4">
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Hassle-free process
                                    </p>
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Flexible repayment options
                                    </p>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-12 mb-4">
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Quick disbursals
                                    </p>
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Minimum documentation
                                    </p>
                                </div>
                                <div className="col-xl-12 col-lg-12 col-12 mb-5">
                                    <p
                                        className="b-color ps-2"
                                        style={{
                                            borderLeft: "solid #1F7A2E 4px",
                                        }}
                                    >
                                        Collateral-free & Collateral-based
                                        Business Loans
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

LoanDetailsContainer.propTypes = {
    classOption: PropTypes.string,
};

export default LoanDetailsContainer;
